import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from './common/LoadingSpinner';
import { websiteUrl } from '../config/env';

/**
 * Redirects to the marketing site (e.g. /contact on localhost:3000).
 */
export default function WebsiteExternalRedirect({ path = '' }) {
  const { isAuthenticated, loading } = useSelector((state) => state.auth);
  const target = `${websiteUrl.replace(/\/+$/, '')}${path.startsWith('/') ? path : `/${path}`}`;

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      window.location.replace(target);
    }
  }, [loading, isAuthenticated, target]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <LoadingSpinner />;
}
